import CardCommon from '@op/components/CardCommon';
import React, { useMemo } from 'react';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';
import { getFeedsKeywordText, useLocalLanguage } from '@op/utils/languageValue';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import { useKeyOpinionsRisingKeyword } from '@op/pages/Overview/KeyOpinions/hook';
import { reviewsFormat } from '@op/utils/value';
import { formatDateFunc, getFilterDateQOQText } from '@op/utils/time';
import { keyOpinionsRisingKeywords } from '@op/components/BubbleCommon/copywritingKey/keyOpinions';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import moment from 'moment';
import './index.scss';

export default function RisingKeywords({
  filter,
  languageType,
}: any) {
  const { formatMessage } = useLocalLanguage({
    languageType: languageType || 'origin',
  });

  const ExtraFilter = useMemo(()=>({
    ...filter,
    is_valid: [2,1,3],
    social_media_by_account: undefined,
    social_media_by_keyword: undefined,
    top_n: 20,
  }),[filter]);

  const { data, loading } = useKeyOpinionsRisingKeyword({
    filter: ExtraFilter,
    extraData: '',
  });
  const { text } = getFilterDateQOQText(filter);

  const formatDate = useMemo(
    () =>
      filter?.date_type === 'daily' &&
      moment(filter?.start_time).isSame(moment(), 'day') &&
      moment(filter?.end_time).isSame(moment(), 'day')
        ? formatDateFunc('hourly')
        : formatDateFunc(filter?.date_type),
    [filter],
  );

  return (
    <CardCommon
      className={data?.list?.length === 0 ? "dbo-rising-keywords-empty":"dbo-rising-keywords"}
      title={
        <div className="dbo-rising-keywords-title">
          <span>{formatMessage({ id: 'Rising Keywords' })}</span>
          <BubbleCommon tipsMap={keyOpinionsRisingKeywords} placement={'top'} />
        </div>
      }
      contentCard
      loading={loading}
      hasEmptyDesc={false}
      empty={data?.list?.length === 0}
      loadingHeight={50}
      emptyHeight={120}
    >
      <div className="dbo-rising-keywords-inner dbh-rising-keywords-inner">
        {data?.list?.map((item, index) => (
          <div
            key={index}
            className={`rising-keywords-item`}
          >
            <RingRatioBubble
              formateValue={reviewsFormat}
              formateDate={formatDate}
              oldTime={item.oldTime}
              newTime={item.newTime}
              oldValue={item.old_count}
              newValue={item.count}
              otherInfo={
                <PercentageItem
                  percentage={item?.ratio}
                  className="dbo-rising-keywords-percent"
                />
              }
              title={`${formatMessage({ id: 'Keyword' })} ${formatMessage({
                id: text,
              })}`}
            >
              <span className="rising-keywords-item-text">
                {getFeedsKeywordText(item, languageType || 'origin')}
              </span>
              <span className="rising-keywords-item-num">{item.count}</span>
            </RingRatioBubble>
          </div>
        ))}
      </div>
    </CardCommon>
  );
}
